<template>
    <div class="detailsContainer">
        <h1>wyszukaj nieruchomość</h1>
        <div class="form">
            <div class="group">
                <select
                    required=""
                    name="typ"
                    data-val=""
                    style="width:270px;"
                    v-model="state.rodzaj"
                >
                    <option value="65535">Wszystkie</option>
                    <optgroup label="Ogólnie">
                        <option value="18439">Domy</option>
                        <option value="10144">Mieszkania</option>
                        <option value="24">Działki</option>
                        <option value="4160">Lokale</option>
                    </optgroup>
                    <optgroup label="Szczegółowo">
                        <option value="1">1/2 Bliźniaka</option>
                        <option value="2">Budynek</option>
                        <option value="4">Dom</option>
                        <option value="8">Działka</option>
                        <option value="16">Grunty</option>
                        <option value="32">Kawalerka</option>
                        <option value="64">Lokal</option>
                        <option value="128">Mieszkanie jednopokojowe</option>
                        <option value="256">Mieszkanie dwupokojowe</option>
                        <option value="512">Mieszkanie trzypokojowe</option>
                        <option value="1024">Mieszkanie czteropokojowe i +</option>
                        <option value="2048">Kamienica</option>
                        <option value="4096">Obiekt komercyjny</option>
                        <option value="8192">MDM</option>
                        <option value="16384">Szeregowiec</option>
                    </optgroup>
                </select>
                <label>Rodzaj obiektu</label>
            </div>

            <div class="group">
                <select
                    required=""
                    name="transakcja"
                    data-val=""
                    style="width:270px;"
                    v-model="state.typ"
                >
                    <option value="-">Wszystkie</option>
                    <option value="s">Sprzedaż</option>
                    <option value="w">Wynajem</option>
                </select>
                <label>Typ oferty</label>
            </div>

            <div class="group l2">
                <select
                    required=""
                    width="150"
                    name="miejscowosc"
                    data-val=""
                    style="width:270px;"
                    v-model="state.miejscowosc"
                >
                    <option value="-">Wszystkie</option>
                    <option value="BLACHOWNIA">BLACHOWNIA</option>
                    <option value="GLIWICE">GLIWICE</option>
                    <option value="HERBY">HERBY</option>
                    <option value="JANOW">JANÓW</option>
                    <option value="KAMIENICA_POLSKA">KAMIENICA POLSKA</option>
                    <option value="KLOBUCK">KŁOBUCK</option>
                    <option value="KLOMNICE">KŁOMNICE</option>
                    <option value="KONOPISKA">KONOPISKA</option>
                    <option value="KOZIEGLOWY">KOZIEGŁOWY</option>
                    <option value="KRUSZYNA">KRUSZYNA</option>
                    <option value="MIEDZNO">MIEDZNO</option>
                    <option value="MIEDZNO">MIEDŹNO</option>
                    <option value="MSTOW">MSTÓW</option>
                    <option value="MYKANOW">MYKANÓW</option>
                    <option value="OLSZTYN">OLSZTYN</option>
                    <option value="PANKI">PANKI</option>
                    <option value="POCZESNA">POCZESNA</option>
                    <option value="POPOW">POPÓW</option>
                    <option value="PORAJ">PORAJ</option>
                    <option value="REDZINY">RĘDZINY</option>
                    <option value="SECEMIN">SECEMIN</option>
                    <option value="SKRAJNICA_">SKRAJNICA</option>
                    <option value="SOBUCZYNA">SOBUCZYNA</option>
                    <option value="UJSOLY">UJSOŁY</option>
                    <option value="WISLA">WISŁA</option>
                    <option value="WRECZYCA">WRECZYCA</option>
                    <option value="WRECZYCA_WIELKA">WRĘCZYCA WIELKA</option>
                </select>
                    <label>Miejscowość</label>
            </div>

            <div class="group l1 active">
                <select
                    required=""
                    name="dzielnica"
                    data-val=""
                    style="width:270px;"
                    v-model="state.dzielnica"
                >
                    <option value="-">Wszystkie</option>
                    <option value="ANOLOW">ANOŁÓW</option>
                    <option value="BLESZNO">BŁESZNO</option>
                    <option value="BOR">BÓR</option>
                    <option value="BRZEZINY">BRZEZINY</option>
                    <option value="BUGAJ">BUGAJ</option>
                    <option value="CENTRUM">CENTRUM</option>
                    <option value="CZESTOCHOWA">CZĘSTOCHOWA</option>
                    <option value="DABIE">DĄBIE</option>
                    <option value="DZBOW">DŹBÓW</option>
                    <option value="GNASZYN">GNASZYN</option>
                    <option value="GRABOWKA">GRABÓWKA</option>
                    <option value="KAMIENICA_POLSKA">KAMIENICA POLSKA</option>
                    <option value="KAWODRZA">KAWODRZA</option>
                    <option value="KUZNICA">KUŹNICA</option>
                    <option value="LISINIEC">LISINIEC</option>
                    <option value="MIROW">MIRÓW</option>
                    <option value="OKOL._JASNEJ_GORY">OKOL. JASNEJ GÓRY</option>
                    <option value="OKOLICE_JASNEJ_GORY">OKOLICE JASNEJ GÓRY</option>
                    <option value="OSTATNI_GROSZ">OSTATNI GROSZ</option>
                    <option value="PARKITKA">PARKITKA</option>
                    <option value="POLNOC">PÓŁNOC</option>
                    <option value="RAKOW">RAKÓW</option>
                    <option value="RAKOW-ZACHOD">RAKÓW-ZACHÓD</option>
                    <option value="SABINOW">SABINÓW</option>
                    <option value="STARE_MIASTO">STARE MIASTO</option>
                    <option value="STRADOM">STRADOM</option>
                    <option value="SRODMIESCIE">ŚRÓDMIEŚCIE</option>
                    <option value="TRZECH_WIESZCZOW">TRZECH WIESZCZÓW</option>
                    <option value="TYSIACLECIE">TYSIĄCLECIE</option>
                    <option value="WIERZCHOWISKO">WIERZCHOWISKO</option>
                    <option value="WYCZERPY">WYCZERPY</option>
                    <option value="ZACISZE">ZACISZE</option>
                    <option value="ZAWODZIE">ZAWODZIE</option>
                </select>
                <label>Dzielnica</label>
            </div>

            <div class="group">
                <input
                    style="width:270px;"
                    type="text"
                    required=""
                    width="100"
                    name="powOd"
                    v-model="state.powierzchniaOd"
                >
                <label>Powierzchnia od</label>
            </div>

            <div class="group">
                <input
                    style="width:270px;"
                    type="text"
                    required=""
                    width="100"
                    name="powDo"
                    v-model="state.powierzchniaDo"
                >
                <label>Powierzchnia do</label>
            </div>

            <div class="group">
                <input
                    style="width:270px;"
                    type="text"
                    required=""
                    width="100"
                    name="cenaOd"
                    v-model="state.cenaOd"
                >
                <label>Cena od</label>
            </div>

            <div class="group">
                <input
                    style="width:270px;"
                    type="text"
                    required=""
                    width="100"
                    name="cenaDo"
                    v-model="state.cenaDo"
                >
                <label>Cena do</label>
            </div>

        </div>
        <div style="text-align: center">
            <button @click="formClear">wyczyść</button>
            <button @click="formSubmit">szukaj</button>
        </div>
    </div>
</template>

<script>
import { useState } from "@/state";

export default {
    name: "SearchBox",
    data () {
        return {
            state: useState()
        }
    },
    created () {
        this.searchProperty();
    },
    methods: {
        async searchProperty () {
            try {
                let response = await fetch(
                    process.env.VUE_APP_XHR,
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            mode: 'list',
                            type: 'search',
                            params: {
                                typ: this.state.typ,
                                rodzaj: this.state.rodzaj,
                                miejscowosc: this.state.miejscowosc,
                                dzielnica: this.state.dzielnica,
                                powierzchniaOd: this.state.powierzchniaOd,
                                powierzchniaDo: this.state.powierzchniaDo,
                                cenaOd: this.state.cenaOd,
                                cenaDo: this.state.cenaDo,
                                strona: this.state.strona
                            },
                            page: this.$route.params.page || 1
                        })
                    }
                )
                this.state.listOffers = await response.json();
            } catch (err) {
                console.log(err)
            }
        },
        formClear () {
            this.state.typ = '-';
            this.state.rodzaj = 65535;
            this.state.miejscowosc = '-';
            this.state.dzielnica = '-';
            this.state.powierzchniaOd = 1;
            this.state.powierzchniaDo = 99999999;
            this.state.cenaOd = 1;
            this.state.cenaDo = 99999999;
            this.state.strona = 1;
        },
        formSubmit () {
            this.$router.replace('/search/list/1');
            this.searchProperty();
        }
    }
}
</script>

<style lang="scss" scoped>
.detailsContainer {
    max-width: 1200px;
    margin: 30px auto;
    background: #ffffff;
    padding: 20px;

    > h1 {
        text-align: center;
        font: 32px 'Google Sans';
        color: var(--red);
        text-transform: uppercase;
        margin-bottom: 30px;
        padding-bottom: 20px;
    }

    > .form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
    }
}

.group {
    margin: 15px 0;
    display: inline-block;
    position: relative;
}

input[type=text],
select {
    font: 1em 'Roboto Condensed';
    color: #000;
    padding: 10px 10px 10px 5px;
    display: block;
    background: 0 0;
    border: 1px solid #aaa;

    &:focus {
        outline: 0;
        border: 1px solid var(--red);
        transition: .5s ease all
    }
}

input[type=text]:focus ~ label,
input[type=text]:valid ~ label,
select:focus ~ label,
select:valid ~ label {
    top: -20px;
    font-size: 16px;
    color: var(--red);
}

textarea {
    width: 300px;
    height: 300px;
    font: 1em 'Roboto Condensed';
    color: #000;
    padding: 10px 10px 10px 5px;
    display: block;
    border: none;
    background: 0 0;
    border-bottom: 2px solid #aaa;

    &:focus {
        outline: 0;
        border-bottom: 2px solid var(--red);
        transition: .5s ease all
    }

    &:focus ~ label,
    &:valid ~ label {
        top: -.8em;
        font-size: .8em;
        color: var(--red);
    }
}

label {
    font: 1em 'Roboto Condensed';
    color: #999;
    font-weight: 400;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 10px;
    transition: .2s ease all
}

select {
    display: inline-block;
    width: 400px
}

button {
    display: inline-block;
    width: 300px;
    height: 3em;
    padding: 0;
    font: 1em/3em 'Roboto Condensed';
    text-transform: uppercase;
    border: none;
    background-color: var(--button-gray);
    cursor: pointer;
    color: #000;
    transition: background-color .5s ease, color .5s;
    margin: 10px 20px;

    &:hover {
        background-color: var(--button-red);
        color: #fff
    }
}

</style>